import { string, object } from 'yup'

export interface ICreatePasswordSchema {
    password: string
    passwordConf: string
}

const createPasswordSchema = object().shape({
    password: string().required('Preencha o campo com a nova senha.').max(20, 'Máx 20 caracteres'),
    passwordConf: string()
        .required('Preencha o campo com a confirmação da nova senha.')
        .max(20, 'Máx 20 caracteres')
        .test('passwordsShouldBeTheSame', 'As senhas devem ser iguais', function (passwordConf) {
            return passwordConf === this.parent.password
        }),
})

export default createPasswordSchema
